<template>
  <div class="Box">
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="5" class="mb20">
            <el-form-item label="ID：">
              <el-input v-model="queryParams.id" @change="search" @clear="search" placeholder="请输ID"
                clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="5" class="mb20">
            <el-form-item label="回传标题：" label-width="120px">
              <el-input v-model="queryParams.title" @change="search" @clear="search" placeholder="请输入回传标题"
                clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="5" class="mb20">
            <el-form-item label="渠道号：" label-width="120px">
              <el-input v-model="queryParams.channel_code_list" @change="search" @clear="search" placeholder="请输入渠道号"
                clearable></el-input>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="5" class="mb20">
            <el-form-item label="状态：" label-width="100px">
              <el-select v-model="queryParams.status" placeholder="请选择状态" @change="search" @clear="search" clearable
                class="w100">
                <el-option label="隐藏" :value="0"></el-option>
                <el-option label="正常" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="5" class="mb20">
            <el-form-item label="推广链接名称：" label-width="120px">
              <el-input v-model="queryParams.channel_name" placeholder="请输入推广链接名称" @change="search" @clear="search"
                clearable></el-input>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="5" class="mb20">
            <el-form-item label="小说名称：" label-width="120px">
              <el-input v-model="queryParams.movie_name" placeholder="请输入短剧名称" @change="search" @clear="search"
                clearable></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="5" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button size="medium" @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="Addad">添加</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="AddPei">默认配置</el-button>
        <!-- <el-button size="medium" type="primary" @click="AddBulist">补传</el-button> -->
        <!--				<el-button size="medium" type="primary" icon="el-icon-search" @click="addSearch">打开搜索</el-button>-->
      </div>
      <el-table ref="multipleTable" :data="tableData" size="medium" tooltip-effect="dark"
        style="width: 100%; text-align: center; margin-top: 10px" :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }" border v-loading="loading">
        <el-table-column label="ID" width="80">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>
        <el-table-column label="回传标题">
          <template slot-scope="scope">{{ scope.row.title }}</template>
        </el-table-column>
        <!-- <el-table-column label="回传链路">
          <template slot-scope="scope">
            <span v-if="scope.row.limit_type == 1">广告计划</span>
            <span v-else>渠道号</span>
          </template>
        </el-table-column>
        <el-table-column label="渠道号/广告计划">
          <template slot-scope="scope">{{ scope.row.channel_code_list }}</template>
        </el-table-column> -->

        <el-table-column label="选择规则">
          <template slot-scope="scope">{{ scope.row.ad_event_type_name }}</template>
        </el-table-column>
        <el-table-column label="更新时间">
          <template slot-scope="scope">{{ scope.row.updated_at }}</template>
        </el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="handleUpdate(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize"
        @pagination="getList" />

      <div class="drawer-wrapper">
        <el-drawer :wrapperClosable="true" :title="title" :close-on-click-modal="false" :visible.sync="dialogVisible"
          size="50%" :before-close="handleClose">
          <div class="demo-drawer__content" style="margin: auto; width: 90%">
            <el-form :model="AddqueryParams" size="medium" label-width="100px" class="mt35" :rules="rules"
              ref="ruleForm">
              <el-form-item label="回传标题：" prop="title">
                <el-input v-model="AddqueryParams.title" placeholder="请输入回传标题" clearable></el-input>
              </el-form-item>
              <el-form-item label="转化目标：" prop="event_type">
                <el-select v-model="AddqueryParams.event_type" class="w100" placeholder="请选择平台类型"
                  :disabled="this.AddqueryParams.id ? true : false">
                  <el-option label="付费" :value="3"></el-option>
                  <!-- <el-option label="有效获客" :value="4"></el-option> -->
                </el-select>
              </el-form-item>
              <el-form-item label="回传链路：" prop="limit_type">
                <el-radio-group v-model="AddqueryParams.limit_type" @input="radioEdit"
                  :disabled="this.AddqueryParams.id ? true : false">
                  <el-radio :label="0">渠道号</el-radio>
                  <el-radio :label="1">广告计划</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- <el-form-item label="渠道号：" prop="channel_code_list" v-if="AddqueryParams.limit_type == 0">
                <SelectChecked :options="referralOptions" placeholder="请选择渠道号" :isRemoveAllTag="isRemoveAllTag"
                  @selectedVal="selectedReferral" />
              </el-form-item> -->
              <!--            <el-form-item label="广告计划ID：" prop="channel_code_list" v-if="AddqueryParams.limit_type == 1">-->
              <!--              <el-input v-model="AddqueryParams.channel_code_list" placeholder="广告计划ID之间用英文逗号隔开，例如：10,20"-->
              <!--                        clearable></el-input>-->
              <!--            </el-form-item>-->
              <el-form-item label="回传类型：" prop="ad_event_type_id">
                <el-select placeholder="请选择平台类型" class="w100" v-model="platformType">
                  <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <br />
                <el-radio-group v-if="platformType == 1" v-model="AddqueryParams.ad_event_type_id">
                  <div style="display: flex; flex-direction: column; margin-top: 10px">
                    <el-radio :label="item.id" v-for="item in typeList[0].list" :key="item.id"
                      style="margin-bottom: 10px">{{
                      item.name }}
                    </el-radio>
                  </div>
                </el-radio-group>
                <el-radio-group v-if="platformType == 2" v-model="AddqueryParams.ad_event_type_id">
                  <div style="display: flex; flex-direction: column; margin-top: 10px">
                    <el-radio :label="item.id" v-for="item in typeList[1].list" :key="item.id"
                      style="margin-bottom: 10px">{{
                      item.name }}
                    </el-radio>
                  </div>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="回传用户：" prop="is_dyed">
                <el-radio-group v-model="AddqueryParams.is_dyed">
                  <el-radio :label="0">注册用户</el-radio>
                  <el-radio :label="1">激活用户（含染色用户）</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="直接回传：">
                每日前
                <el-input-number style="width: 170px;" v-model="AddqueryParams.pass_total" controls-position="right"
                  :min="0" placeholder="请输入正整数回传"></el-input-number>
                笔回传
              </el-form-item>
              <el-form-item label="回传金额：" v-model="AddqueryParams.money_rule">
                <el-button type="primary" size="medium" style="margin-right: 6px" @click="addMoney">添加</el-button>
                <el-button size="medium" style="margin-right: 0px" @click="explain">说明</el-button>
                <div style="margin-top: 20px; width: 560px" v-if="MoneyShow"
                  v-for="(item, index) in AddqueryParams.money_rule" :key="index">
                  <div style="display: flex">
                    <i class="el-icon-delete" style="font-size: 24px" @click="delItem(index)"></i>
                    <el-form-item :prop="'money_rule.' + index + '.min'"
                      :rules="[{ required: true, message: '金额不能为空', trigger: 'change' }]">
                      <el-input-number v-model="item.min" controls-position="right" :step="0.01" :min="0"
                        style="width: 130px;" placeholder=">最小金额"></el-input-number>
                    </el-form-item>
                    <el-form-item :prop="'money_rule.' + index + '.max'"
                      :rules="[{ required: true, message: '金额不能为空', trigger: 'change' }]">
                      <el-input-number v-model="item.max" controls-position="right" :step="0.01" :min="0"
                        placeholder="<=最大金额" style="margin-left: 6px;width: 135px;"></el-input-number>
                    </el-form-item>
                    <el-form-item :prop="'money_rule.' + index + '.type'"
                      :rules="[{ required: true, message: '必填项', trigger: 'change' }]">
                      <el-radio-group v-model="item.type" style="margin-top: 10px; margin-left: 5px">
                        <el-radio :label="1">全部不会传</el-radio>
                        <el-radio :label="2">自定义回传</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                  <div v-if="item.type == 2" style="margin-top: 18px; display: flex">
                    <div style="width: 0px;">回</div>
                    <el-form-item style="padding-left: 24px" :prop="'money_rule.' + index + '.ratelimitA'"
                      :rules="[{ required: true, message: '回传笔数x不能为空', trigger: 'change' }]">
                      <el-input-number style="width: 127px;" v-model="item.ratelimitA" controls-position="right"
                        :min="0"></el-input-number>
                    </el-form-item>
                    <div style="width: 16px;margin-left: 8px;">卡</div>
                    <el-form-item style="padding-left: 6px" :prop="'money_rule.' + index + '.ratelimitB'"
                      :rules="[{ required: true, message: '总笔数y不能为空', trigger: 'change' }]">
                      <el-input-number style="width: 127px;" v-model="item.ratelimitB" controls-position="right"
                        :min="0"></el-input-number>
                    </el-form-item>
                    <div style="width: 30px;margin-left: 10px;">比例</div>
                    <el-form-item style="padding-left: 6px" :prop="'money_rule.' + index + '.money_rate'"
                      :rules="[{ required: true, message: '回传金额比例不能为空', trigger: 'change' }]">
                      <el-input-number style="width: 150px;" placeholder="请输入0-100" v-model="item.money_rate"
                        controls-position="right" :min="0"></el-input-number>
                    </el-form-item>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>

          <div class="demo-drawer__footer">
            <el-button @click="dialogVisibleDone">取 消</el-button>
            <el-button type="primary" @click="AddSub">确 定</el-button>
          </div>

        </el-drawer>
      </div>
      <!-- 回传规则 -->
      <div class="drawer-wrapper">
        <el-drawer :title="title" :wrapperClosable="true" :close-on-click-modal="false"
          :visible.sync="dialogVisibleMoren" size="50%" :before-close="handleCloseMo">
          <div class="demo-drawer__content" style="margin: auto; width: 90%">
            <el-form :model="AddqueryParams" size="medium" label-width="100px" class="mt35" :rules="rulesmo"
              ref="ruleForm">
              <el-form-item label="转化目标：" prop="event_type">
                <el-select v-model="AddqueryParams.event_type" class="w100" placeholder="请选择平台类型">
                  <el-option label="付费" :value="3"></el-option>
                  <!-- <el-option label="有效获客" :value="4"></el-option> -->
                </el-select>
              </el-form-item>
              <el-form-item label="回传链路：" prop="limit_type">
                <el-radio-group v-model="AddqueryParams.limit_type">
                  <el-radio :label="0">渠道号</el-radio>
                  <el-radio :label="1">广告计划</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="回传类型：" prop="event_type">
                <el-select placeholder="请选择平台类型" class="w100" v-model="platformType">
                  <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <br />
                <el-radio-group v-if="platformType == 1" v-model="AddqueryParams.ad_event_type_id">
                  <div style="display: flex; flex-direction: column; margin-top: 10px">
                    <el-radio :label="item.id" v-for="item in typeList[0].list" :key="item.id"
                      style="margin-bottom: 10px">{{
                      item.name }}
                    </el-radio>
                  </div>
                </el-radio-group>
                <el-radio-group v-if="platformType == 2" v-model="AddqueryParams.ad_event_type_id">
                  <div style="display: flex; flex-direction: column; margin-top: 10px">
                    <el-radio :label="item.id" v-for="item in typeList[1].list" :key="item.id"
                      style="margin-bottom: 10px">{{
                      item.name }}
                    </el-radio>
                  </div>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="回传用户：" prop="is_dyed">
                <el-radio-group v-model="AddqueryParams.is_dyed">
                  <el-radio :label="0">注册用户</el-radio>
                  <el-radio :label="1">激活用户（含染色用户）</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="直接回传：">
                每日前
                <el-input-number v-model="AddqueryParams.pass_total" controls-position="right"
                  :min="0"></el-input-number>
                笔回传
              </el-form-item>
              <el-form-item label="回传金额：" v-model="AddqueryParams.money_rule">
                <el-button type="primary" size="medium" style="margin-right: 6px" @click="addMoney">添加</el-button>
                <el-button size="medium" style="margin-right: 0px" @click="explain">说明</el-button>
                <div style="margin-top: 20px; width: 560px" v-if="MoneyShow"
                  v-for="(item, index) in AddqueryParams.money_rule" :key="index">
                  <div style="display: flex">
                    <i class="el-icon-delete" style="font-size: 24px" @click="delItem(index)"></i>
                    <el-form-item :prop="'money_rule.' + index + '.min'"
                      :rules="[{ required: true, message: '金额不能为空', trigger: 'change' }]">
                      <el-input-number v-model="item.min" controls-position="right" :step="0.01" :min="0"
                        style="width: 130px;" placeholder=">最小金额"></el-input-number>
                    </el-form-item>
                    <el-form-item :prop="'money_rule.' + index + '.max'"
                      :rules="[{ required: true, message: '金额不能为空', trigger: 'change' }]">
                      <el-input-number v-model="item.max" controls-position="right" :step="0.01" :min="0"
                        placeholder="<=最大金额" style="margin-left: 6px;width: 135px;"></el-input-number>
                    </el-form-item>
                    <el-form-item :prop="'money_rule.' + index + '.type'"
                      :rules="[{ required: true, message: '必填项', trigger: 'change' }]">
                      <el-radio-group v-model="item.type" style="margin-top: 10px; margin-left: 5px">
                        <el-radio :label="1">全部不会传</el-radio>
                        <el-radio :label="2">自定义回传</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                  <div v-if="item.type == 2" style="margin-top: 18px;display: flex">
                    <div style="width: 0px;">回</div>
                    <el-form-item style="padding-left: 24px" :prop="'money_rule.' + index + '.ratelimitA'"
                      :rules="[{ required: true, message: '回传笔数x不能为空', trigger: 'change' }]">
                      <el-input-number style="width: 127px;" v-model="item.ratelimitA" controls-position="right"
                        :min="0"></el-input-number>
                    </el-form-item>
                    <div style="width: 16px;margin-left: 8px;">卡</div>
                    <el-form-item style="padding-left: 6px" :prop="'money_rule.' + index + '.ratelimitB'"
                      :rules="[{ required: true, message: '总笔数y不能为空', trigger: 'change' }]">
                      <el-input-number style="width: 127px;" v-model="item.ratelimitB" controls-position="right"
                        :min="0"></el-input-number>
                    </el-form-item>
                    <div style="width: 30px;margin-left: 10px;">比例</div>
                    <el-form-item style="padding-left: 6px" :prop="'money_rule.' + index + '.money_rate'"
                      :rules="[{ required: true, message: '回传金额比例不能为空', trigger: 'change' }]">
                      <el-input-number style="width: 150px;" placeholder="请输入0-100" v-model="item.money_rate"
                        controls-position="right" :min="0"></el-input-number>
                    </el-form-item>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>

          <div class="demo-drawer__footer">
            <el-button @click="dialogVisibleMorenDone">取 消</el-button>
            <el-button type="primary" @click="AddSubB">确 定</el-button>
          </div>

        </el-drawer>
      </div>

      <AddBu :AddBu="AddBu" @NoneDlog="NoneDlog"></AddBu>
      <Explain :dialogVisibleExplain="dialogVisibleExplain" @NoneDlogs="NoneDlogs"></Explain>
    </el-card>
  </div>
</template>

<script>
import { ToutiaoAPI } from '@/api/Apiret/index';
import AddBu from './component/Bu.vue';
import Explain from './component/explainList.vue';
import { processErrors } from "@/utils/errorHandler";
import { GeneralCollectApi } from '@/api/statistics/comStatistics/index';
import SelectChecked from '@/components/Select/SelectChecked'

export default {
  name: 'Dyret',
  components: {
    AddBu,
    Explain,
    SelectChecked
  },
  data() {
    return {
      title: '',
      tableData: [],
      SearchFlag: false,
      platformType: 1,
      queryParams: {
        id: '',
        title: '',
        channel_code_list: '',
        status: '',
        channel_name: '',
        movie_name: '',
        pageNo: 1,
        pageSize: 10,
        type:9
      },
      AddqueryParams: {
        id: null,
        title: '',
        is_global: 0,
        event_type: 3,
        limit_type: 1,
        channel_code_list: '',
        ad_event_type_id: '',
        is_dyed: 1,
        pass_total: '',
        money_rule: [],
      },
      money: {
        min: undefined,
        max: undefined,
        type: 2,
        ratelimitA: 0,
        ratelimitB: 0,

        ratelimit: '',
      },
      formAdd: {},
      MoneyShow: false,
      rules: {
        title: [{ required: true, message: '请输入回传标题', trigger: 'blur' }],
        event_type: [{ required: true, message: '请输入转化目标', trigger: 'blur' }],
        limit_type: [{ required: true, message: '请输入回传链路', trigger: 'blur' }],
        channel_code_list: [{ required: true, message: '请输入渠道号', trigger: 'blur' }],
        ad_event_type_id: [{ required: true, message: '请输入回传类型', trigger: 'blur' }],
        is_dyed: [{ required: true, message: '请输入回传用户', trigger: 'blur' }],
      },
      rulesmo: {
        event_type: [{ required: true, message: '请输入转化目标', trigger: 'blur' }],
        limit_type: [{ required: true, message: '请输入回传链路', trigger: 'blur' }],
        ad_event_type_id: [{ required: true, message: '请输入回传类型', trigger: 'blur' }],
        is_dyed: [{ required: true, message: '请输入回传用户', trigger: 'blur' }],
      },
      dialogVisible: false,
      dialogVisibleMoren: false,
      AddBu: false,
      dialogVisibleExplain: false,
      total: 0,
      typeList: [],
      referralOptions: [],//选择渠道号列表
      isRemoveAllTag: 0,
      money_rule_List: [],
      loading: false,
    };
  },

  methods: {
    dialogVisibleDone() {
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false
    },
    dialogVisibleMorenDone() {
      this.$refs['ruleForm'].resetFields();
      this.dialogVisibleMoren = false
    },
    search() {
      this.getList();
    },
    reset() {
      this.queryParams = {
        id: '',
        title: '',
        channel_code_list: '',
        status: '',
        channel_name: '',
        movie_name: '',
        pageNo: 1,
        pageSize: 10,
        type:9
      }
      this.getList();
    },
    addSearch() {
      this.SearchFlag = !this.SearchFlag;
    },
    NoneDlog() {
      this.AddBu = false;
    },
    NoneDlogs() {
      this.dialogVisibleExplain = false;
    },
    // 说明
    explain() {
      this.dialogVisibleExplain = true;
    },
    AddBulist() {
      this.AddBu = true;
    },

    /**
     * 获取选择渠道号列表
     */
    getSelectReferral() {
      const api = GeneralCollectApi();
      let params = {
        media: 'TT'
      };
      api.getSelectReferral(params)
        .then((res) => {
          if (res.code == 0) {
            let data = res.data;
            this.referralOptions = data.map(item => ({
              value: item.channel_code,
              label: item.channel_code,
              label_en: item.novel_name + '-' + item.chapters_name + '-' + item.channel_name,
              check: false
            }));

            if (this.AddqueryParams.channel_code_list) {
              this.referralOptions = this.referralOptions.map(item => {
                return {
                  ...item,
                  check: this.AddqueryParams.channel_code_list.split(',').includes(item.value)
                };
              });
            }
          } else {
            processErrors(res);
          }
        })
        .catch((error) => {
        });
    },

    /**
     * 选择渠道号
     */
    selectedReferral(value) {
      this.AddqueryParams.channel_code_list = value.join(',');
    },

    radioEdit(event) {
      this.AddqueryParams.channel_code_list = '';
      if (event == 0) {
        this.referralOptions = this.referralOptions.map(item => ({
          value: item.value,
          label: item.label,
          label_en: item.label_en,
          check: false
        }));
      }
    },

    //添加弹窗
    Addad() {
      this.getSelectReferral();
      this.isRemoveAllTag = 0;
      this.dialogVisible = true;
      this.title = '添加';
      this.AddqueryParams = {
        id: null,
        title: '',
        is_global: 0,
        event_type: 3,
        limit_type: 1,
        channel_code_list: '',
        ad_event_type_id: '',
        is_dyed: 1,
        pass_total: '',
        money_rule: [],
      };
      (this.money = {
        min: undefined,
        max: undefined,
        type: 2,
        money_rate: 100,
        ratelimitA: 0,
        ratelimitB: 0,
        ratelimit: '',
      }),
        (this.MoneyShow = false);
      this.getType();
    },
    AddPei() {
      this.dialogVisibleMoren = true;
      let params = {
        id: 0,
        type: 1,
        is_global: 9,
      };

      const api = ToutiaoAPI();
      api
        .getDetail(params)
        .then((res) => {

          if (res.code == -1) {
            this.AddqueryParams = {
              id: null,
              title: '',
              is_global: 0,
              event_type: 3,
              limit_type: 1,
              channel_code_list: '',
              ad_event_type_id: '',
              is_dyed: 1,
              pass_total: '',
              money_rule: [],
            };
            this.getType();
          } else {
            console.log(res,'获取的数据信息')
            this.platformType = res.data.ad_event_recharge_type + 1
            this.MoneyShow = true;
            this.AddqueryParams.title = res.data.title;
            this.AddqueryParams.is_global = res.data.is_global;
            this.AddqueryParams.event_type = res.data.event_type;
            this.AddqueryParams.limit_type = res.data.limit_type >= 0 ? res.data.limit_type : 1;
            this.AddqueryParams.channel_code_list = res.data.channel_code_list;
            this.AddqueryParams.ad_event_type_id = res.data.ad_event_type_id;
            this.AddqueryParams.is_dyed = res.data.is_dyed;
            this.AddqueryParams.pass_total = res.data.pass_total;
            this.AddqueryParams.money_rule = res.data.extends.money_rule;
            this.money_rule_List = res.data.extends.money_rule
            // this.AddqueryParams.money_rule = JSON.parse(res.data.extends.money_rule);
            this.AddqueryParams.id = res.data.id;
            this.money.ratelimitA = res.data.extends.money_rule[0].ratelimit.split('/')[0];
            this.money.ratelimitB = res.data.extends.money_rule[0].ratelimit.split('/')[1];
            this.AddqueryParams.money_rule.forEach((obj) => {
              obj.ratelimitA = obj.ratelimit.split('/')[0];
              obj.ratelimitB = obj.ratelimit.split('/')[1];
              delete obj.ratelimit;
            });
          }
        })
        .catch((error) => {
          console.error('Error fetching user data:', error);
          this.loading = false;
        });
    },
    delItem(index) {
      this.AddqueryParams.money_rule.splice(index, 1);
    },
    // 添加push
    addMoney() {
      this.MoneyShow = true;
      if (this.money_rule_List) {
        this.AddqueryParams.money_rule.push({
          min: undefined,
          max: undefined,
          type: this.money.type,
          money_rate: 100,
          ratelimitA: 0,
          ratelimitB: 0
        });
      } else {
        this.AddqueryParams.money_rule.push({
          min: this.money.min,
          max: this.money.max,
          type: this.money.type,
          money_rate: this.money.money_rate,
          ratelimitA: this.money.ratelimitA,
          ratelimitB: this.money.ratelimitB
        });
      }

    },
    //确定添加按钮
    AddSub() {

      this.AddqueryParams.money_rule.forEach((obj) => {
        // obj.ratelimit = `${this.money.ratelimitA}/${this.money.ratelimitB}`;
        obj.ratelimit = `${obj.ratelimitA}/${obj.ratelimitB}`;
        obj.money_rate = String(obj.money_rate)
        obj.min = String(obj.min)
        obj.max = String(obj.max)
      });

      let params = {
        ...this.AddqueryParams,
        money_rule: JSON.stringify(this.AddqueryParams.money_rule),
        platformType: this.platformType,
        type:9
      };

      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.AddqueryParams.id == null) {

            const api = ToutiaoAPI();
            api
              .getAdd(params)
              .then((res) => {
                if (res.code == 0) {
                  this.$message({
                    message: '添加成功',
                    type: 'success',
                  });

                  this.dialogVisible = false;
                  this.getList();
                } else {
                  processErrors(res);
                }
              })
              .catch((error) => {
                console.error('Error fetching user data:', error);
                this.loading = false;
              });
          } else {
            let paramsB = { ...this.AddqueryParams, money_rule: JSON.stringify(this.AddqueryParams.money_rule) };
            let paramsC = { ...paramsB, money_rule: JSON.parse(paramsB.money_rule) };

            paramsC.money_rule.forEach((obj) => {
              obj.ratelimit = `${obj.ratelimitA}/${obj.ratelimitB}`;
              obj.min = String(obj.min)
              obj.max = String(obj.max)
            });
            let paramsD = { ...paramsC, money_rule: JSON.stringify(paramsC.money_rule) };

            const api = ToutiaoAPI();
            api
              .getEdit(paramsD)
              .then((res) => {
                if (res.code == 0) {
                  this.$message({
                    message: '修改成功',
                    type: 'success',
                  });

                  this.dialogVisible = false;
                  this.getList();
                } else {
                  processErrors(res);
                }
              })
              .catch((error) => {
                console.error('Error fetching user data:', error);
                this.loading = false;
              });
          }
        }
        this.isRemoveAllTag += 1;
      });
    },
    //默认添加
    AddSubB() {
      this.AddqueryParams.money_rule.forEach((obj) => {
        obj.ratelimit = `${obj.ratelimitA}/${obj.ratelimitB}`;
        // obj.ratelimit = `${this.money.ratelimitA}/${this.money.ratelimitB}`;
        obj.money_rate = String(obj.money_rate)
        obj.min = String(obj.min)
        obj.max = String(obj.max)
      });


      let params = {
        ...this.AddqueryParams,
        money_rule: JSON.stringify(this.AddqueryParams.money_rule),
        is_global: 1,
        platformType: this.platformType,
        type:9
      };
      console.log(params,'数据信息111')
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.AddqueryParams.id == null) {
            const api = ToutiaoAPI();
            api
              .getAdd(params)
              .then((res) => {
                if (res.code == 0) {
                  this.$message({
                    message: '添加成功',
                    type: 'success',
                  });

                  this.dialogVisibleMoren = false;
                  this.getList();
                } else {
                  processErrors(res);
                }
              })
              .catch((error) => {
                console.error('Error fetching user data:', error);
                this.loading = false;
              });
          } else {
            let paramsB = { ...this.AddqueryParams, money_rule: JSON.stringify(this.AddqueryParams.money_rule) };
            let paramsC = { ...paramsB, money_rule: JSON.parse(paramsB.money_rule) };

            paramsC.money_rule.forEach((obj) => {
              obj.ratelimit = `${obj.ratelimitA}/${obj.ratelimitB}`;
              obj.min = String(obj.min)
              obj.max = String(obj.max)
            });
            let paramsD = { ...paramsC, money_rule: JSON.stringify(paramsC.money_rule) };
            const api = ToutiaoAPI();
            api
              .getEdit(paramsD)
              .then((res) => {
                if (res.code == 0) {
                  this.$message({
                    message: '修改成功',
                    type: 'success',
                  });

                  this.dialogVisibleMoren = false;
                  this.getList();
                } else {
                  processErrors(res);
                }
              })
              .catch((error) => {
                console.error('Error fetching user data:', error);
                this.loading = false;
              });
          }
        }
      });
    },

    //编辑广告详情
    handleUpdate(row) {
      this.platformType = row.ad_event_recharge_type + 1
      this.dialogVisible = true;
      this.isRemoveAllTag = 0;
      this.title = '编辑';
      let params = {
        id: row.id,
        type: 9,
        is_global: 0,
      };
      const api = ToutiaoAPI();
      api
        .getDetail(params)
        .then((res) => {
          this.MoneyShow = true;
          this.AddqueryParams.title = res.data.title;
          this.AddqueryParams.is_global = res.data.is_global;
          this.AddqueryParams.event_type = res.data.event_type;
          this.AddqueryParams.limit_type = res.data.limit_type >= 0 ? res.data.limit_type : 1;
          this.AddqueryParams.channel_code_list = res.data.channel_code_list;
          this.AddqueryParams.ad_event_type_id = res.data.ad_event_type_id;
          this.AddqueryParams.is_dyed = res.data.is_dyed;
          this.AddqueryParams.pass_total = res.data.pass_total;
          this.AddqueryParams.money_rule = res.data.extends.money_rule;
          this.AddqueryParams.id = res.data.id;

          this.getSelectReferral();
        })
        .catch((error) => {
          console.error('Error fetching user data:', error);
          this.loading = false;
        });
    },
    //列表
    getList() {
      this.loading = true
      const api = ToutiaoAPI();
      api
        .getTTList(this.queryParams)
        .then((res) => {
          if (res.code == 0) {
            let arr = {
                
            }
            this.tableData = res.data.data;
            this.total = res.data.totalCount;
          } else {
            processErrors(res);
          }
          this.loading = false
        })
        .catch((error) => {
          console.error('Error fetching user data:', error);
          this.loading = false;
        });
    },
    //获取回传类型
    getType() {
      const api = ToutiaoAPI();
      api
        .getType()
        .then((res) => {
          if (res.code == 0) {
            this.typeList = res.data.data;
            this.typeList.forEach((item) => {
              if (item.id === this.platformType) {
                this.AddqueryParams.ad_event_type_id = item.list.find((it) => it.is_default == 1)?.id;
              }
            });
          } else {
            processErrors(res);
          }
        })
        .catch((error) => {
          console.error('Error fetching user data:', error);
          this.loading = false;
        });
    },
    handleClose(done) {
      this.dialogVisible = false;
      this.isRemoveAllTag += 1;
      (this.money = {
        min: undefined,
        max: undefined,
        money_rate: "",
        type: 2,
        ratelimitA: '',
        ratelimitB: '',
        ratelimit: '',
      }),
        this.$refs['ruleForm'].resetFields();
    },
    handleCloseMo() {
      this.dialogVisibleMoren = false;
      this.$refs['ruleForm'].resetFields();
    },
  },
  mounted() {
    this.getList();
    this.getType();
  },
};
</script>

<style lang="scss" scoped>
.Box {
  & ::v-deep el-card__body {
    padding: 0 !important;
  }

  .el-form-item__label {
    width: 100px !important;
  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.demo-drawer__content {
  height: calc(100% - 80px);
  /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto;
  /* 添加垂直滚动条 */
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px;
  /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}
</style>
